<template>
  <div class="sri-page-header mt-4">
    <div class="search md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100">
        <isis-autocomplete
          v-model="studentData.displayValue"
          :value.sync="studentData.value"
          :options="studentOpts"
          :refetchOptions="
            queryObj =>
              studentData.refetchOptions(studentData.displayValue, queryObj)
          "
          :fields="studentData.fields"
          :label="studentData.label"
          fetchOnOpen
        />
      </div>
      <div class="md-layout-item md-size-70 md-small-size-100">
        <md-button @click.prevent="button.action" class="md-info mr-6">
          {{ $t(button.title) }}
        </md-button>
        <div class="float-right">
          <md-button
            class="md-warning"
            @click.prevent="$emit('export-pdf')"
            v-if="showExport"
          >
            {{ $t("common.export") }}
          </md-button>
          <md-button
            class="md-success ml-3"
            @click.prevent="bulkActions.action"
            v-if="canImport"
          >
            {{ $t(bulkActions.content) }}
          </md-button>
        </div>
      </div>
      <import-xlsx-modal
        :name="importModalName"
        title="smi_sri.import_ielts"
        :actions="importCSVModalActions"
        :formatImportedData="formatImportedData"
      >
        <template #template-desc>
          <p class="template-desc">
            {{ $t("common.download") }}
            <a @click="downloadTemplate" style="cursor: pointer">
              {{ $t("smi_sri.xlsx_template") }}
            </a>
            {{ $t("common.see_an_example_of_the_format_required") }}
          </p>
        </template>
      </import-xlsx-modal>
    </div>
  </div>
</template>

<script>
import ImportXlsxModal from "@/components/Base/ImportXlsxModal";
import { IELTS_IMPORT_FILE } from "@/constants";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { service_paths } from "@/constants/Services";
import { initLoader, Message } from "@/helpers/utils";
import { IndividualAssessment } from "@/constants/Permissions";

const tableColumn = IELTS_IMPORT_FILE;

export default {
  props: ["button", "data", "showExport"],
  components: { ImportXlsxModal },
  data() {
    return {
      importModalName: "importIELTS",
      studentOpts: [],
      studentData: {
        label: "smi_sri.search_by_full_name",
        value: "",
        displayValue: "",
        fields: {
          text: "full_name_id",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getStudentOpts(selectedValue, queryObj);
        }
      },
      bulkActions: {
        content: "common.import_file",
        action: () => {
          this.$modal.show(this.importModalName);
        }
      },
      formatImportedData: this.formatDataTable,
      importCSVModalActions: {
        primary: {
          title: "common.upload_and_continue",
          action: this.uploadFileToS3
        }
      },
      templateDownload: {
        templateLink: `${service_paths.ielts}/template`,
        templateName: "ielts-report.xlsx"
      }
    };
  },
  computed: {
    canImport() {
      return this.$can(
        IndividualAssessment.actions.import,
        IndividualAssessment.subject
      );
    }
  },
  methods: {
    getStudentOpts(value) {
      return this.$axios
        .get(
          service_paths.students + `/filter-with-role`,
          {
            search_key: value,
            fields: ["full_name", "student_code"]
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          // get memorized selected when modal is opened
          this.studentOpts = data.data;
          this.studentOpts = this.studentOpts.map(student => ({
            full_name_id: student.full_name.concat(
              " - ",
              student.student_code || ""
            ),
            ...student
          }));
        });
    },
    downloadTemplate() {
      return this.$axios
        .get(this.templateDownload.templateLink, {}, true, {}, "blob")
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.templateDownload.templateName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    formatDataTable(file) {
      return file?.map(student => ({
        [tableColumn.studentCode]: student[tableColumn.studentCode],
        [tableColumn.testName]: student[tableColumn.testName],
        [tableColumn.overall]: student[tableColumn.overall],
        [tableColumn.listening]: student[tableColumn.listening],
        [tableColumn.reading]: student[tableColumn.reading],
        [tableColumn.testDate_s]: student[tableColumn.testDate_s],
        [tableColumn.fc]: student[tableColumn.fc],
        [tableColumn.lr]: student[tableColumn.lr],
        [tableColumn.gr]: student[tableColumn.gr],
        [tableColumn.p]: student[tableColumn.p],
        [tableColumn.bandScore_s]: student[tableColumn.bandScore_s],
        [tableColumn.testDate_w]: student[tableColumn.testDate_w],
        [tableColumn.task_1]: student[tableColumn.task_1],
        [tableColumn.task_2]: student[tableColumn.task_2],
        [tableColumn.bandScore_w]: student[tableColumn.bandScore_w],
        [tableColumn.speakingComment]: student[tableColumn.speakingComment],
        [tableColumn.writingComment]: student[tableColumn.writingComment]
      }));
    },
    async uploadFileToS3(file) {
      const loader = initLoader();
      const s3FolderPath = AWSConst.S3_IMPORT_STUDENT_PATH;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(savedLink, `${service_paths.ielts}/import`);
        this.$modal.hide(this.importModalName);
        Message.success(this.$t("smi_sri.importXLSX"));
      } finally {
        loader.hide();
      }
    }
  },
  watch: {
    "studentData.value"(newValue) {
      if (newValue) {
        this.$emit("studentValue", this.studentData.value);
      }
    },
    "studentData.displayValue"(newValue) {
      if (!newValue) {
        this.$emit("studentValue", "");
      }
    }
  }
};
</script>
